<template>
  <div>
    <el-row class="form-item">
      <el-col>物料信息</el-col>
      <el-col>
        <el-table :data="tradeBmApplyDetailList" class="order-data-table ie-table">
          <el-table-column label="物料名称">
            <template slot-scope="scope">
              <el-input placeholder="请填写物料名称" v-model="scope.row.itemName" ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="物料数量">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.itemQty" :min="1"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="物料品牌">
            <template slot-scope="scope">
              <el-select v-model="scope.row.subBrandCode" placeholder="选择物料品牌" clearable filterable @change="brandChange($event, scope.$index)">
                <el-option
                  v-for="item in brandList"
                  :label="item.brandName"
                  :value="item.abiBrandCode"
                  :key="item.abiBrandCode"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200px">
            <template slot-scope="scope">
              <el-button class="btn-blue-plain add-col-btn" type="primary" size="small" plain @click="addMaterial(scope.$index)">新增</el-button>
              <el-button :disabled="tradeBmApplyDetailList.length === 1" class="btn-blue-plain delete-col-btn" type="danger" size="small" plain @click="delMaterial(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'trade-apply-material',
  props: {
    tradeBmApplyDetailList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      brandList: []
    }
  },
  created () {
    this.getSubBrand()
  },
  methods: {
    // 获取子品牌
    getSubBrand () {
      this.$store.dispatch('getSubBrand').then(res => {
        if (res.data.resultCode === '0') {
          this.brandList = res.data.resultData.brandList || []
          if (this.brandList.length) {
            this.brandList = this.brandList.filter(brand => {
              return Boolean(brand.brandGroup)
            })
            this.brandList = this.brandList.map(item => {
              return {
                ...item,
                brandName: item.abiBrandName + (item.brandGroup ? (' - ' + item.brandGroup) : '')
              }
            })
          }
        }
      })
    },

    // 选择品牌
    brandChange (e, index) {
      if (e) {
        this.tradeBmApplyDetailList[index].brandGroup = this.brandList.filter(item => {
          return item.abiBrandCode === e
        })[0].brandGroup
      } else {
        this.tradeBmApplyDetailList[index].brandGroup = ''
      }
      console.log(this.tradeBmApplyDetailList)
    },

    // 新增
    addMaterial (index) {
      this.tradeBmApplyDetailList.push({
        itemName: '',
        itemQty: null,
        subBrandCode: ''
      })
    },

    // 删除
    delMaterial (index) {
      this.tradeBmApplyDetailList.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item {
  padding: $content-large;
}
</style>
